import { useMemo } from 'react';
import { Box, Panel, PanelSection, Text } from '@customerio/pluma-components/react';
import { EventSelectionFieldset, IntegrationStateToggle, SendFrequencyRadios } from '@/features/integrations';
import { isMParticleEnableLocked } from '@/services/db/mparticle-integration/entity';
import { getMParticleEventGroups } from '@/utils/mparticle-events';

export type MParticleSettings = {
  enabled: boolean;
  events: string[];
  resolution: boolean;
};

type SettingsFormProps = {
  settings: MParticleSettings;
  isReadOnly: boolean;
  onChange: (settings: MParticleSettings) => void;
};

/** Which events to forward, whether forwarding is on, and how often to send. */
export function SettingsForm({ settings, isReadOnly, onChange }: SettingsFormProps) {
  const groups = useMemo(() => [...getMParticleEventGroups()], []);

  const isEnableLocked = isMParticleEnableLocked(settings);

  return (
    <>
      <IntegrationStateToggle
        isEnabled={settings.enabled}
        isReadOnly={isReadOnly}
        isEnableLocked={isEnableLocked}
        onChange={(enabled) => onChange({ ...settings, enabled })}
      />

      <PanelSection>
        <EventSelectionFieldset
          groups={groups}
          selectedItems={settings.events}
          isDisabled={isReadOnly}
          onChange={(events) => onChange({ ...settings, events })}
          mb="200"
        />

        <Panel backgroundColor="subtle">
          <PanelSection>
            <Box as="fieldset">
              <Text text="product-h4" as="legend" mb="150">
                Choose send frequency for opens and clicks
              </Text>

              <SendFrequencyRadios
                resolution={settings.resolution}
                isDisabled={isReadOnly}
                onChange={(resolution) => onChange({ ...settings, resolution })}
              />
            </Box>
          </PanelSection>
        </Panel>
      </PanelSection>
    </>
  );
}
